namespace GeniuzPOS.Administration {
    export interface PsConfigRow {
        ConfigId?: number;
        ShopId?: string;
        ConfigTypeId?: string;
        ConfigCode?: string;
        ConfigDate?: string;
        Description?: string;
        LastUpdate?: string;
        UpdateBy?: string;
        IsActive?: boolean;
    }

    export namespace PsConfigRow {
        export const idProperty = 'ConfigId';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'Administration.PsConfig';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ConfigId = "ConfigId",
            ShopId = "ShopId",
            ConfigTypeId = "ConfigTypeId",
            ConfigCode = "ConfigCode",
            ConfigDate = "ConfigDate",
            Description = "Description",
            LastUpdate = "LastUpdate",
            UpdateBy = "UpdateBy",
            IsActive = "IsActive"
        }
    }
}
